import Access from './access/default.svg';
import Add from './add/default.svg';
import Android from './android/default.svg';
import Apple from './apple/default.svg';
import Casino from './casino/default.svg';
import Click from './click/default.svg';
import Code1 from './code 1/default.svg';
import Code2 from './code 2/default.svg';
import Copy from './copy/default.svg';
import Download from './download/default.svg';
import DropdownArrow from './dropdown arrow/default.svg';
import Edit from './edit/default.svg';
import ExpandMore from './expand more/default.svg';
import Export from './export/default.svg';
import File from './file/default.svg';
import GridView from './grid view/default.svg';
import Help from './help/default.svg';
import History from './history/default.svg';
import ImageIcon from './image/default.svg';
import Inventory from './inventory/default.svg';
import ListView from './list view/default.svg';
import More from './more/default.svg';
import Native from './native/default.svg';
import Notification from './notification/default.svg';
import Observe from './observe/default.svg';
import Upload from './upload/default.svg';
import Pause from './pause/default.svg';
import Play from './play/default.svg';
import Search from './search/default.svg';
import Settings from './settings/default.svg';
import Football from './football/default.svg';
import Stop from './stop/default.svg';
import ToolsMenu from './tools_menu/default.svg';
import Trash from './trash/default.svg';
import Triggers from './triggers/default.svg';
import UserAccount from './user_account/default.svg';
import Variables from './variables/default.svg';
import VideoIcon from './video/default.svg';
import Web from './web/default.svg';
import Refresh from './refresh/default.svg';

export default {
    Access,
    Add,
    Android,
    Apple,
    Casino,
    Click,
    Code1,
    Code2,
    Copy,
    Download,
    DropdownArrow,
    Edit,
    ExpandMore,
    Export,
    File,
    GridView,
    Help,
    History,
    ImageIcon,
    Inventory,
    ListView,
    More,
    Native,
    Notification,
    Observe,
    Upload,
    Pause,
    Play,
    Search,
    Settings,
    Football,
    Stop,
    ToolsMenu,
    Trash,
    Triggers,
    UserAccount,
    Variables,
    VideoIcon,
    Web,
    Refresh,
};
